import styled from "styled-components";

export const BackButton = styled.button`
  background: none;
  border: none;
  color: #fff;
  font-family: Figtree;
  font-size: 15px;
  font-weight: 400;
  letter-spacing: -0.075px;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  margin-left: -7px;
  opacity: 0.5;
  transition: all 0.2s ease-in-out;
  &:hover {
    opacity: 1;
  }
`;

export const PopupOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 998;
`;

export const AnnouncementsPopup = styled.div`
  display: flex;
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  width: 361px;
  max-width: calc(100vw - 32px);
  padding: 16px 12px 16px 16px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 10px;
  z-index: 999;

  border-radius: 16px;
  border: 1.5px solid #112742;
  background: linear-gradient(180deg, #0b356b 0%, #11253e 100%);

  /* Animacija */
  opacity: ${(props) => (props.$isVisible ? 1 : 0)};
  transform: ${(props) =>
    props.$isVisible
      ? "translateY(0) scale(1)"
      : "translateY(-10px) scale(0.95)"};
  transition:
    opacity 0.2s ease-out,
    transform 0.2s ease-out;
`;

export const PopupTitleContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  justify-content: space-between;
`;

export const PopupTitle = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: -0.09px;
`;

export const PopupText = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
`;

export const PopupButton = styled.button`
  color: #0f2c32;
  font-family: Figtree;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: -0.08px;

  display: flex;
  height: 44px;
  padding: 12px 24px;
  justify-content: center;
  align-items: center;
  gap: 4px;

  border-radius: 100px;
  background: #fff;
  transition: all 0.3s ease-in-out;

  cursor: pointer;
  outline: none;

  &:active {
    scale: 0.975;
  }
`;

export const AnnouncementsButtonContainer = styled.div`
  position: relative;
`;

export const AnnouncementsButton = styled.button`
  border-radius: 100px;
  border: 1.5px solid #112742;
  background: linear-gradient(180deg, #0b356b 0%, #11253e 100%);
  outline: none;

  cursor: pointer;
  display: inline-flex;
  height: 24px;
  padding: 8px 12px;
  justify-content: center;
  align-items: center;
  gap: 10px;
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
  margin-top: ${(p) => (p.$offMarginTop ? "0px" : "16px")};
  /* margin-top: 12px; */
  flex-wrap: wrap;
  @media (max-width: 354px) {
    gap: 12px;
  }
`;

export const PageTitle = styled.h1`
  color: #fff;
  font-family: Figtree;
  font-size: 26px;
  font-weight: 500;
  line-height: 150%; /* 30px */
  letter-spacing: -0.1px;
  white-space: nowrap;
`;

export const Counter = styled.div`
  display: inline-flex;
  height: 28px;
  padding: 0 8px;
  align-items: center;
  white-space: nowrap;
  border-radius: 12px;
  border: 1px solid #fbbd33;
  background: #ffcb3b;
  box-shadow: 0 4px 12px 0 rgba(221, 162, 0, 0.36);
  width: 164px;
  color: #0a1a2f;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: -0.07px;
`;

export const SectionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Section = styled.div`
  display: flex;
  padding: 12px;
  flex-direction: row;
  align-items: flex-start;
  gap: 16px;
  border-radius: 12px;
  border: 1px solid #193154;
`;

export const SectionIcon = styled.div`
  width: 48px;
  height: 48px;
  background: linear-gradient(0deg, #66033c -47.22%, #a3005e 100%);

  border: 1px solid #942160;
  background: #0d1a2e;
  box-shadow: 0 -1px 9.5px 0 #9b0859 inset;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;

  font-size: 20px;
  flex-shrink: 0;
`;
export const ReferralRewardsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  align-items: center;
  flex: 1;
  padding: 0 10px;
`;
export const LoaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
`;
export const SectionContent = styled.div`
  flex: 1;
  max-width: 500px;
  max-width: 355px;
  width: 100%;
`;
export const Line = styled.div`
  margin: 8px 0rem;
  display: flex;
  align-self: center;
  max-width: 355px;
  width: 100%;
  height: 2px;
  background: linear-gradient(
    90deg,
    rgba(14, 14, 18, 0) 0%,
    #3e7fce 50%,
    rgba(14, 14, 18, 0) 100%
  );
`;
export const SectionTitle = styled.h3`
  color: #a1caff;

  text-align: center;
  text-shadow: 0 1px 1px rgba(77, 141, 255, 0.42);
  /* font-family: Figtree */
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.1px;
  margin-bottom: 6px;
`;

export const SectionDescription = styled.p`
  color: #fff;

  font-family: Figtree;
  font-size: 15px;

  font-weight: 400;
  line-height: 20px; /* 133.333% */
  margin-bottom: 16px;
`;

export const SectionDescriptionFirst = styled.p`
  color: #feffff;
  text-align: center;
  font-feature-settings:
    "liga" off,
    "clig" off;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 133.333% */
  margin-bottom: 15px;
`;

export const SectionDescriptionSecond = styled.p`
  color: #fff;
  opacity: 0.5;
  font-family: Figtree;
  font-size: 14px;

  font-weight: 400;
  line-height: 20px;
  margin-bottom: 16px;
`;

export const TimerContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
`;

export const TimerLabel = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 16px;

  font-weight: 400;

  margin-top: 16px;
  letter-spacing: -0.4px;
`;

export const Timer = styled.div`
  font-size: 18px;
  font-weight: 700;
  padding: 12px 24px;
  font-family: Figtree;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  width: fit-content;
  color: #a3005e;
`;

export const Divider = styled.div`
  height: 1px;
  background: #162b49;
`;

export const ReferralLinkContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;

  width: 100%;
  margin: 16px auto;
  max-width: 291px;
`;

export const ReferralLink = styled.div`
  border-radius: 100px;
  border: 1px solid #3d68a9;
  background: linear-gradient(176deg, #05224f 3.6%, #0f4e9e 96.4%);
  box-shadow: 0 4px 24px 0 #081120;
  display: flex;
  padding: 12px 18px;
  justify-content: space-between;
  align-items: center;
  flex: 1;

  color: #fff;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
  text-decoration: underline;
  justify-content: center;

  border-radius: 100px;
  border: 1px solid #3d68a9;
  background: linear-gradient(176deg, #05224f 3.6%, #0f4e9e 96.4%);
  box-shadow: 0 4px 24px 0 #081120;

  span {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const CopyButton = styled.button`
  cursor: pointer;
  transition: all 0.3s ease;
  justify-content: center;
  font-family: Figtree;
  border: none;
  outline: none;

  display: flex;
  height: 44px;
  padding: 9px 16px;
  justify-content: center;
  align-items: center;
  gap: 10px;

  border-radius: 100px;
  background: #fff;

  &:hover:not(:disabled) {
    transform: translateY(-1px);
  }

  @media (max-width: 450px) {
    align-self: flex-end;
  }
`;

export const ProgressContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 355px;
  width: 100%;
`;

export const ProgressBar = styled.div`
  width: 100%;
  height: 8px;
  background: #193154;
  border-radius: 4px;
  overflow: hidden;
`;

export const ProgressFill = styled.div`
  width: ${(props) => props.$progress}%;
  height: 100%;
  /* background: linear-gradient(90deg, #a3005e, #c4057a); */
  background: #fff;
  border-radius: 4px;
  transition: width 0.5s ease;
`;

export const ProgressText = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 12px;
  text-transform: capitalize;
  font-weight: 400;
  line-height: 150%; /* 18px */
  letter-spacing: 0.06px;
`;

export const CollectButton = styled.button`
  display: ${(props) => (!props.$invite ? "flex" : "none")};
  height: 40px;
  flex-direction: row;
  padding: 9px 20px 9px 16px;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
  gap: 10px;

  border-radius: 100px;
  border: none;
  outline: none;
  background: #fff;

  color: #081120;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 600;
  line-height: 150%;
  letter-spacing: 0.07px;

  cursor: pointer;

  &:disabled {
    color: white;
    cursor: not-allowed;
    background: #142743;
  }
  @media (max-width: 768px) {
    display: flex;
  }
`;

export const StyledRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;
